import { Fragment, ReactNode, useState } from 'react';

import Toolbar from 'modules/shared/components/navigation/toolbar';
import SideDrawer from 'modules/shared/components/navigation/side-drawer';

type Props = {
  children: ReactNode;
};

const Layout = ({ children }: Props) => {
  const [showSideDrawer, setShowSideDrawer] = useState(false);

  const sideDrawerClosedHandler = () => {
    setShowSideDrawer(false);
  };

  const sideDrawerToggleHandler = () => {
    setShowSideDrawer(!showSideDrawer);
  };

  return (
    <Fragment>
      <Toolbar drawerToggleClicked={sideDrawerToggleHandler} />
      <SideDrawer open={showSideDrawer} closed={sideDrawerClosedHandler} />
      <main>{children}</main>
    </Fragment>
  );
};

export default Layout;
